export default {
  path: '/backups',
  name: 'backups',
  component: () => import('../components/backup/Layout'),
  redirect: { name: 'BackupList' },
  meta: {
    breadcrumb: 'administration.backup.backups',
  },
  children: [
    {
      name: 'BackupList',
      path: '',
      component: () => import('../views/backup/List'),
      meta: {
        breadcrumb: 'global.list',
      },

    },
    {
      name: 'BackupShow',
      path: ':id',
      component: () => import('../views/backup/Show'),
      meta: {
        breadcrumb: 'administration.backup.backup',
      },
    }
  ]
};
